import { TextField } from '@material-ui/core'
import { AutocompleteRenderInputParams } from '@material-ui/lab'
import { graphql } from 'babel-plugin-relay/macro'
import { Field } from 'formik'
import { Autocomplete } from 'formik-material-ui-lab'
import { isNull } from 'lodash'
import React, { useEffect, useState } from 'react'
import { fetchQuery, useRelayEnvironment } from 'react-relay/hooks'
import { useFieldFast } from '../../hooks/useFieldFast'
import { ParentShipmentFieldQuery } from '../../__generated__/ParentShipmentFieldQuery.graphql'
import ItemImage from '../ItemImage'
import { FieldT, FieldVariantEnum } from './types'

interface Props {
  field: FieldT
  variant?: FieldVariantEnum
}

const ParentShipmentField: React.FC<Props> = ({ field }) => {
  const [, meta, helpers] = useFieldFast(field.name)
  const [, containerMeta] = useFieldFast('containerSlug')
  const environment = useRelayEnvironment()
  const [options, setOptions] = useState([])
  useEffect(() => {
    if (containerMeta.value === '' || isNull(containerMeta.value) || containerMeta.value === undefined) {
      helpers.setValue('')
    }
    fetchQuery<ParentShipmentFieldQuery>(environment, query, {
      type: 'shipments',
      searchQuery: '',
      parentAbsoluteSlug: `containers/${containerMeta.value}`,
    })
      .toPromise()
      .then((data) => data?.itemList.items.edges?.map((edge) => edge?.node) || [])
      .then((opts) => setOptions(opts as never[]))
  }, [containerMeta.value, environment, helpers])

  return (
    <Field
      name={field.name}
      component={Autocomplete}
      options={options}
      getOptionLabel={(option: any) => (typeof option === 'string' ? option : option?.title || '')}
      getOptionSelected={(option: any, value: string) => option.slug === value}
      value={meta.value}
      onChange={(_: any, value: any) => (value ? helpers.setValue(value.slug) : helpers.setValue(null))}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          error={meta.touched && !!meta.error}
          helperText={meta.touched ? meta.error : null}
          label={field.title}
          variant='outlined'
        />
      )}
      renderOption={(option: any) => (
        <>
          <ItemImage data={option.image} variant='small' />
          {option.title}
        </>
      )}
    />
  )
}

const query = graphql`
  query ParentShipmentFieldQuery($type: ListItemTypeEnum!, $parentAbsoluteSlug: String!, $searchQuery: String) {
    itemList(type: $type, parentAbsoluteSlug: $parentAbsoluteSlug, searchQuery: $searchQuery) {
      items {
        edges {
          node {
            slug
            title
            image {
              ...ItemImage_data
            }
          }
        }
      }
    }
  }
`

export default ParentShipmentField
